import {injectable} from "inversify";
import {RateAppPanel} from "@/scenes.ui/rate-app-panel";
import {AppRateType} from "@/store/player/types";
import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {CapacitorService} from "@/services/capacitor-service";

@injectable()
export class RateAppService {

    public async open(scene: Scene, canvas: HTMLCanvasElement, appRateType: AppRateType, onAcceptCallback: () => void) {
        let rateText = "";
        switch (appRateType) {
            case AppRateType.ANDROID_GOOGLE:
                rateText = Tr('rt.on.google');
                break;
            case AppRateType.YANDEX:
                rateText = Tr('rt.on.yan');
                break;
        }
        new RateAppPanel(scene, canvas, rateText, onAcceptCallback).openAnimated();
    }
}